export default "# When the project just clicks. \n\nProfessionalism and going with wase";